export const links = {
  home: "/",
  login: "/login",
  howToPlay: "/how-to-play",
  createAccount: "/create-account",
  eventRegistration: "/event-registration",
  rodEventRegistration: "/rally-on-demand-registration",
  news: "/news",
  swag: "/swag",
  product: "/product/:productId",
  checkout: "/checkout",
  activity: "/activity",
  contact: "/contact",
  events: "/events",
  pastEvents: "/past-events",
  privateEvents: "/private-events",
  pastEvent: "/past-event/:eventId",
  results: "/results",
  eventPK: "/event/:pk",
  mobileRegistration: "/events/:eventId/teams/:teamId/mobileRegistration",
  teams: "/teams",
  explore: "/explore",
  ranking: "/ranking",
  collection: "/collection",
  gallery: "/gallery",
  logout: "/logout",
  adminHome: "/admin",
  adminLogin: "/admin/login",
  manage: "/admin",
  admin: {
    events: {
      edit: {
        details: "/admin/events/edit/details",
        puzzles: "/admin/events/edit/puzzles",
        startingLocations: "/admin/events/edit/starting-locations",
        participants: "/admin/events/edit/participants",
        coupons: "/admin/events/edit/coupons",
        status: "/admin/events/edit/status",
        stats: "/admin/events/edit/stats",
      },
      puzzles: {
        test: "/admin/events/puzzles/test",
      },
    },
    pastEvents: {
      edit: {
        details: "/admin/past-events/edit/details",
        puzzles: "/admin/past-events/edit/puzzles",
        startingLocations: "/admin/past-events/edit/starting-locations",
        participants: "/admin/past-events/edit/participants",
        coupons: "/admin/past-events/edit/coupons",
        status: "/admin/past-events/edit/status",
        stats: "/admin/past-events/edit/stats",
      },
      puzzles: {
        test: "/admin/past-events/puzzles/test",
      },
    },
    reports: {
      event: "/admin/reports/event",
      pastEvent: "/admin/reports/past-event",
      byTime: "/admin/reports/by-time",
      allPast: "/admin/reports/all-past",
    },
    sessionReports: {
      event: "/admin/session-reports/event",
    },
    eventSeasons: {
      edit: {
        details: "/admin/event-seasons/edit/details",
        prizes: "/admin/event-seasons/edit/prizes",
      },
    },
  },
  profile: "/profile",
  forgotPassword: "/forgot-password",
  verifyEmail: "/verify-email",
};

export default links;
